import { jsx as _jsx } from "react/jsx-runtime";
import { RateIcon } from '@icons';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import useFocusNew from '../common/effects/useFocusNew';
import { isDark } from '../common/utils';
import styles from './rate.module.scss';
const RateItem = ({ active, disabled, focusable, hovered, icon, id, index, onMouseOver, onSelect, size = 'sm', }) => {
    const ref = React.useRef(null);
    const isDarkMode = useMemo(() => isDark(), []);
    useFocusNew(focusable && !disabled ? ref : null, focusable ? () => onSelect(index) : null);
    const rateItemClass = useMemo(() => classNames(styles.item, {
        [styles.active]: active,
        [styles[size]]: true,
        [styles.disabled]: disabled,
        [styles.hovered]: hovered,
        [styles.dark]: isDarkMode,
    }), [active, hovered, disabled]);
    const focusableProps = useMemo(() => focusable && {
        ref,
        tabIndex: 0,
    }, []);
    const disabledProps = useMemo(() => disabled && {
        'aria-disabled': disabled,
    }, [disabled]);
    return (_jsx("li", { className: rateItemClass, onMouseOver: () => onMouseOver(index), "aria-checked": active, role: "radio", ...focusableProps, ...disabledProps, children: _jsx("span", { role: "img", onClick: () => onSelect(index), "aria-label": "star", children: icon || _jsx(RateIcon, {}) }) }, id));
};
RateItem.displayName = 'RateItem';
export { RateItem };
